import { useSelector } from 'react-redux';

export const EVENT_STATUS = {
    scheduled: 'scheduled',
    live: 'ongoing',
    ended: 'event_ended',
    cancelled: 'cancelled',
    drafted: 'drafted'
};

export const TICKET_STATUS = {
    scheduled: 'scheduled',
    live: 'live',
    soldOut: 'sold_out',
    saleEnded: 'sale_ended',
    commingSoon: 'coming_soon'
};

export const EVENT_TYPES = {
    singleDay: 'single_day',
    multiDay: 'multi_day',
    continuous: 'continuous'
};

export function useEventStatus() {
    const eventStatus = useSelector((state) => state.event?.eventData?.status);
    const tickets = useSelector((state) => state.ticket);
    const eventData = useSelector((state) => state.event?.eventData);

    return {
        isEventLive: eventStatus === EVENT_STATUS.live,
        isEventDrafted: eventStatus === EVENT_STATUS.drafted,
        isEventScheduled: eventStatus === EVENT_STATUS.scheduled,
        isEventEnded: eventStatus === EVENT_STATUS.ended,
        isEventCancelled: eventStatus === EVENT_STATUS.cancelled,
        isEventSingleDay: eventData?.event_type === EVENT_TYPES.singleDay,
        isEventMultiDay: eventData?.event_type === EVENT_TYPES.multiDay,
        isEventContinuous: eventData?.event_type === EVENT_TYPES.continuous,
        isEventPublishedBefore: eventData?.was_published_before,
        shouldShowAddTicketButton: [
            EVENT_STATUS.live,
            EVENT_STATUS.drafted,
            EVENT_STATUS.scheduled
        ].includes(eventStatus),
        isAnyTicketPurchased: tickets?.tickets?.some((ticket) => ticket.ticket_sold > 0) || false,
        // isAnyTicketPurchased: true,
        isLocationTabCompleted: eventData?.is_publishable?.location === 1,
        isScheduleTabCompleted: eventData?.is_publishable?.schedule === 1,
        isDescriptionTabCompleted: eventData?.is_publishable?.description === 1,
        isBasicDetailsTabCompleted: eventData?.is_publishable?.details === 1,
        isMediaTabCompleted: eventData?.is_publishable?.media === 1,
        isTicketCreatedForEvent: tickets?.length > 0
        // isTicketCreatedForEvent: true,
    };
}
